/*
 * @Date: 2024-12-02 17:52:01
 * @Description:项目人员管理
 */
import ProjectPersonList from '../views/project-person-list.vue';

export const route = [
  {
    path: '/main/asp/project-person/list',
    name: 'main-asp-project-person-list',
    meta: {
      title: '项目人员'
    },
    component: ProjectPersonList
  },
  {
    path: '/main/supplier/project-person/list',
    name: 'main-supplier-project-person-list',
    meta: {
      title: '项目人员'
    },
    component: ProjectPersonList
  },
  {
    path: '/main/industry/project-person/list',
    name: 'main-industry-project-person-list',
    meta: {
      title: '项目人员'
    },
    component: ProjectPersonList
  }
];
